import { render, staticRenderFns } from "./NotificationCheckbox.vue?vue&type=template&id=0163daf8"
import script from "./NotificationCheckbox.vue?vue&type=script&lang=js"
export * from "./NotificationCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports